var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isEmpty(_vm.social) && !_vm.isUiMode
    ? _c("div", { staticClass: "social" }, [
        _vm.isShowView
          ? _c(
              "a",
              {
                staticClass: "social-item inline-flex-center",
                attrs: { role: "button" },
              },
              [
                _c("i", { staticClass: "isif isif-view social-icon" }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.social[_vm.icon.view.count]))]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isShowLike
          ? _c(
              "a",
              {
                staticClass: "social-item inline-flex-center clickable",
                class: { active: _vm.isSocialLiked },
                attrs: { role: "button" },
                on: { click: _vm.updateLikeCount },
              },
              [
                _c("i", { staticClass: "isif isif-like social-icon" }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.social[_vm.icon.like.count]))]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isShowComment
          ? _c(
              "a",
              {
                staticClass: "social-item inline-flex-center clickable",
                class: { active: _vm.isCommentsActive },
                attrs: { role: "button" },
                on: { click: _vm.clickComments },
              },
              [
                _c("i", { staticClass: "isif isif-comment social-icon" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.social[_vm.icon.comment.count])),
                ]),
              ]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }